import React, {useMemo} from "react"
import {widgetFromDomaintypeGenerator} from "../../misc/widget-functions"
import Content from "../Content"

const MerkmalToWidgetList = ({merkmalList, rootPointer}) => {
    const widgetList = useMemo(
        () =>
            Array.isArray(merkmalList)
                ? merkmalList.map((merkmal) =>
                      widgetFromDomaintypeGenerator(
                          merkmal,
                          rootPointer + merkmal.pointer,
                      ),
                  )
                : [],
        [],
    )
    return widgetList.map((widget) => <Content child={widget} />)
}

export default MerkmalToWidgetList
